/* import __COLOCATED_TEMPLATE__ from './voice-note-action.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import templateOnlyComponent from '@ember/component/template-only';
import { type DisplayContext } from 'embercom/services/command-k';

interface Signature {
  Args: {
    priority?: number;
    activatingComponent?: `${DisplayContext}`;
    trackingData?: Record<string, unknown>;
    onSelect: () => void;
  };
}

const VoiceNoteAction = templateOnlyComponent<Signature>();
export default VoiceNoteAction;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Composer::CommandK::VoiceNoteAction': typeof VoiceNoteAction;
    'inbox2/composer/command-k/voice-note-action': typeof VoiceNoteAction;
  }
}
